
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem4ExemptGrid extends Serenity.EntityGrid<PsAdvPromoItem4ExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItem4ExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem4ExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItem4ExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem4ExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem4ExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItem4ExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}